// extracted by mini-css-extract-plugin
export default {"instructionText":"instructionCard_instructionText__CbJnq"};